import { SelectedFilter } from '../types/filters.types';

/**
 * Converts an array of SelectedFilter to URL query parameters
 * @param filters Array of selected filters
 * @returns A string in the format filters[key][op]=in&filters[key][val][0]=value1&filters[key][val][1]=value2
 */
export const filtersToQueryParams = (filters: SelectedFilter[]): string => {
  if (!filters || !filters.length) {
    return '';
  }

  // Group filters by key
  const filtersByKey: Record<string, string[]> = {};

  filters.forEach((filter) => {
    if (!filter.key || !filter.values || filter.values.length === 0) {
      return;
    }

    if (!filtersByKey[filter.key]) {
      filtersByKey[filter.key] = [];
    }

    // Add all values to the corresponding key
    filtersByKey[filter.key] = [...filtersByKey[filter.key], ...filter.values];
  });

  const queryParts: string[] = [];

  // Generate query params for each key
  Object.entries(filtersByKey).forEach(([key, values]) => {
    // Add operation parameter only once per key
    queryParts.push(`filters[${key}][op]=in`);

    // Add each filter value with the correct index
    values.forEach((value, index) => {
      queryParts.push(`filters[${key}][val][${index}]=${encodeURIComponent(value)}`);
    });
  });

  return queryParts.join('&');
};
